import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Stack } from '../stack/stack'

type Props = {
  children: ReactNode
  aside?: ReactNode
}

export const Section = ({ aside, children }: Props) => (
  <Stack as="section" className={clsx('section')} row gap={16}>
    {aside && <aside>{aside}</aside>}
    <main>{children}</main>
  </Stack>
)
